import TextPopup from "@/popups/textPopup"
import { CustomWindowEvents } from "@/enums/customWindowEvents"

declare global {
	interface Window {
		TextPopup: typeof TextPopup
		servicesPopup: any
		descriptionPopup: any
	}
}

window.TextPopup = TextPopup

function getServicesText(): string {
	const isWinter = window.seasonManager.isWinter()
	const text = isWinter
		? window.lihe.servicesWinter 
		: window.lihe.servicesSummer 
	return text
}

function getDescriptionText(): string {
	const isWinter = window.seasonManager.isWinter()
	const text = isWinter
		? window.lihe.generalDescriptionWinter || window.lihe.generalDescription
		: window.lihe.generalDescriptionSummer || window.lihe.generalDescription
	return text
}

const initTextPopups = (): void => {

	const servicesShowMoreElement: HTMLDivElement | null = document.querySelector("#services-show-more")
	const descriptionText = getDescriptionText()
	const descriptionPopup = new TextPopup(
		window.lihe.name,
		descriptionText,
		"description-popup",
		"#description-show-more"
	)
	descriptionPopup.initTextPopup()
	window.descriptionPopup = descriptionPopup

	const servicesText = getServicesText()
	if (!servicesText && servicesShowMoreElement) {
		servicesShowMoreElement.style.display = "none"
	} else {
		if (servicesShowMoreElement)  {
			// Ensure that the "Show More Services" element appears when switching seasons,
			// if one of the seasons does not have any services text available.
			servicesShowMoreElement.style.display = "block"
		}
		const servicesPopup = new TextPopup(
			window.content.liheDesc_services,
			servicesText,
			"services-popup",
			"#services-show-more"
		)
		servicesPopup.initTextPopup()
		window.servicesPopup = servicesPopup
	}

	const transportPopUp = new TextPopup(
		"TRANSPORT",
		"Dummy transport content",
		"transport-popup",
		"#transport-show-more"
	)
	transportPopUp.initTextPopup()
	window.transportPopUp = transportPopUp
}

export default async () => {
	initTextPopups()

	window.addEventListener(CustomWindowEvents.CHANGE_SEASON, () => {
		initTextPopups()
	})
}
